import React, { FC } from "react";
import {
  RadioButtonCustom,
  RadioButtonDefault,
  RadioButtonLabel,
  RadioButtonText,
} from "./RadioButton.styles";

interface RadioButtonProps {
  label: string | React.ReactNode;
  // Fires once per activation: a click anywhere on the label is forwarded to
  // the native input, and Space / the arrow keys click it once it has focus.
  onClick: React.MouseEventHandler<HTMLInputElement>;
  disabled?: boolean;
  value: string | undefined;
  checked?: boolean;
  name?: string;
}

const RadioButton: FC<RadioButtonProps> = ({
  label,
  disabled = false,
  onClick,
  checked,
  ...otherProps
}) => (
  <RadioButtonLabel>
    <RadioButtonDefault
      type="radio"
      disabled={disabled}
      onClick={onClick}
      checked={checked}
      readOnly
      {...otherProps}
    />
    <RadioButtonCustom $disabled={disabled} />
    {label && <RadioButtonText>{label}</RadioButtonText>}
  </RadioButtonLabel>
);

export default RadioButton;
